import { Button, AnalyticsEvent } from '@cibli/shared';
import insigneAnime from '@cibli/shared/assets/insigne-vert-noir-anime.svg';
import { Clock, FastForward, MessageCircle, Pause } from 'lucide-react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import Hint from '@/features/common/components/Hint';
import MainLayout from '@/features/common/components/MainLayout';
import { useTrackEvent } from '@/lib/analytics/use-track-event';

interface Props {
  onStart: () => void;
  onCancel: () => void;
}

export default function InterviewIntroScreen({ onStart, onCancel }: Props) {
  const { t } = useTranslation();
  const trackEvent = useTrackEvent();

  const handleStart = useCallback(() => {
    onStart();
    trackEvent({ event: AnalyticsEvent.STARTED_INTERVIEW });
  }, [onStart, trackEvent]);

  return (
    <MainLayout className="gap-8 md:gap-12" onClose={onCancel}>
      <img src={insigneAnime} alt="CibliJob" className="h-24 md:h-32 lg:h-40 mx-auto" />
      <h1 className="text-2xl md:text-3xl lg:text-4xl text-center">{t('Interview.Intro.title')}</h1>
      <div className="flex flex-col gap-4 sm:gap-6 font-semibold">
        <Hint hint={t('Interview.Intro.hints.duration')} icon={<Clock />} />
        <Hint hint={t('Interview.Intro.hints.rythm')} icon={<FastForward />} />
        <Hint hint={t('Interview.Intro.hints.take_time')} icon={<MessageCircle />} />
        <Hint hint={t('Interview.Intro.hints.pause')} icon={<Pause />} />
      </div>
      <Button size="xl" className="w-full sm:w-auto" autoFocus onClick={handleStart}>
        {t('common.start')}
      </Button>
    </MainLayout>
  );
}
